<template>
  <div class="row justify-content-center">
    <div class="col-lg-12 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="col-lg-12">
              <div class="card-header bg-transparent">
                <div class="mx-3 my-2">
                    <h1>¡Cotiza tu cubrecanto desde aquí!</h1>
                    <h3>Completa el siguiente formulario para solicitar una cotización en Canplast México</h3>
                    <small>Los campos que aparecen con un asterísco (*) son obligatorios.</small>
                </div>
              </div>
              <div class="card-body mx-3 my-2">
                <div v-show="!showForm">
                  <div class="form-group row">
                    <div class="col-lg-5">
                      <label class="form-control-label">RFC *</label>
                    </div>
                    <div class="col-lg-4"> 
                      <div class="form-group">
                        <input type="text" 
                              v-model="rfc"
                              placeholder="Escribe el RFC"
                              class="form-control"
                              min="1"
                              required>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="text-right">
                    <base-button @click="validateRFC" :disabled='loadingRFC'>Continuar</base-button>
                  </div>
                </div>
                <form v-show="showForm" @submit.prevent="sendRequest()">
                  <div class="form-group row items-center">
                    <div class="col-lg-5">
                      <label class="form-control-label">Cliente *</label>
                    </div>
                    <div class="col-lg-7"> 
                      <div v-if="razonSocial && cardCode">
                        <span>{{razonSocial}}</span>
                        <p>{{cardCode}}</p>                    
                      </div>
                      <span v-else>
                        <input type="text" 
                          v-model="razonSocial"
                          placeholder="Razón Social"
                          class="form-control mb-3"
                          min="1"
                          required>
                        <p class="ml-2">{{rfc}}</p>
                      </span>
                    </div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <div class="col-lg-5">
                      <label class="form-control-label">Agente de ventas *</label>
                    </div>
                    <div class="col-lg-7"> 
                      <p v-if="agenteVentas">{{agenteVentas.SalesEmployeeName}}</p>
                      <span v-else>Cargando...</span>
                    </div>
                  </div>
                  <hr>
                  
                  <div class="card-body mx-3" v-if="razonSocial">
                    <h3 class="pb-4">Artículos</h3>
                    <div>
                      <form class="row">
                        <div class="form-group row items-center col-xl-4">
                          <div class="col-xl-12">
                            <label class="form-control-label">Linea</label>
                            <multiselect
                              v-model="linea"
                              :options="lineaList"
                              placeholder="Selecciona la linea"
                              @select="onSelectLinea">
                            </multiselect>
                          </div>
                        </div>
                        <div class="form-group row items-center col-xl-4" v-if="linea">
                          <div class="col-xl-12">
                            <label class="form-control-label">Color</label>
                            <multiselect
                              v-model="color"
                              :options="colorList[linea]"
                              placeholder="Selecciona el color">
                            </multiselect>
                          </div>
                        </div>
                        <div class="form-group row items-center col-xl-4" v-if="linea">
                          <div class="col-xl-12">
                            <label class="form-control-label">¿Con adhesivo?:</label>
                            <multiselect
                              v-model="adhesivo"
                              :options="adhesivoList"
                              placeholder="¿Deseas con adhesivo?"
                              :disabled="linea === 'Melamina'">
                            </multiselect>
                          </div>
                        </div>
                        <div class="form-group row items-center col-xl-4" v-if="linea">
                          <div class="col-xl-12">
                            <label class="form-control-label">Ancho</label>
                            <multiselect
                              v-model="ancho"
                              :options="anchoList[linea]"
                              placeholder="Selecciona el ancho">
                            </multiselect>
                          </div>
                        </div>
                        <div class="form-group row items-center col-xl-4" v-if="linea">
                          <div class="col-xl-12">
                            <label class="form-control-label">Espesor</label>
                            <multiselect
                              v-model="espesor"
                              :options="espesorList[linea]"
                              placeholder="Selecciona el espesor">
                            </multiselect>
                          </div>
                        </div>
                        <div class="form-group row items-center col-xl-4" v-if="linea">
                          <div class="col-xl-12">
                            <label class="form-control-label">Acabado</label>
                            <multiselect
                              v-model="acabado"
                              :options="acabadoList[linea]"
                              placeholder="Selecciona el acabdao">
                            </multiselect>
                          </div>
                        </div>
                        <div class="form-group row items-center col-xl-4" v-if="linea">
                          <div class="col-xl-12">
                            <label class="form-control-label">Rollos</label><br>
                            <label>1 rollo = 
                              {{linea === 'PVC' && espesor === '0.45mm' ? '300 mts':''}}
                              {{linea === 'PVC' && espesor === '1mm' ? '150 mts':''}}
                              {{linea === 'PVC' && espesor === '1.8mm' ? '100 mts':''}}
                              {{linea === 'Melamina' && adhesivo === 'Si' ? '100 mts':''}}
                              {{linea === 'Melamina' && adhesivo === 'No' ? '500 mts':''}}
                              {{linea === 'Madera' && adhesivo === 'Si' ? '100 mts':''}}
                              {{linea === 'Madera' && adhesivo === 'No' ? '300 mts':''}}
                            </label>
                            <input type="number" 
                              v-model="cantidad"
                              placeholder="Rollos"
                              class="form-control"
                              min="1"
                              required>
                          </div>
                        </div>
                      </form>
                      <div class="text-right" v-if="linea">
                        <base-button
                          @click="agregarArticulo"
                          class="justify-content-end"
                          type="default"
                          :disabled='false'
                          nativeType="submit">
                          Agregar Artículo 
                          <i class="fa fa-arrow-down ml-2"></i>
                        </base-button>
                      </div>
                      
                    </div>
                    <hr>
                    <div class="row">
                      <div class="col-xl-12">
                        <div v-if="articulosParaCotizar.length > 0">
                          <div class="table-responsive">
                            <base-table thead-classes="thead-light" :data="articulosParaCotizar" class="border">
                              <template v-slot:columns>
                                <th>Linea</th>
                                <th>Color</th>
                                <th>Adhesivo</th>
                                <th>Ancho</th>
                                <th>Espesor</th>
                                <th>Acabado</th>
                                <th>Rollos</th>
                                <th></th>
                              </template> 
                              <template v-slot:default="{row, index}">
                                <th scope="row">{{row.linea}}</th>
                                <th scope="row">{{row.color}}</th>
                                <th scope="row">{{row.adhesivo}}</th>
                                <th scope="row">{{row.ancho}}</th>
                                <th scope="row">{{row.espesor}}</th>
                                <th scope="row">{{row.acabado}}</th>
                                <th scope="row">{{row.cantidad}}</th>
                                <th scope="row" class="text-right">
                                  <base-button icon="far fa-trash-alt" 
                                              type="danger"
                                              iconOnly
                                              @click="deleteArticuloParaCotizar(index)">
                                  </base-button>
                                </th>
                              </template>
                            </base-table>
                          </div>
                          <div class="text-right mt-4">
                            <base-button
                              @click="sendWhatsapp"
                              class="justify-content-end"
                              type="success"
                              :disabled='false'>
                              Enviar por whatsapp
                              <i class="fa fa-arrow-right ml-2"></i>
                            </base-button>
                          </div>
                          
                        </div>
                        <div v-if="!(articulosParaCotizar.length > 0)" class="w-100 h-100 d-flex justify-content-center align-items-center">
                          <div>
                            <center><i class="fa fa-lg fa-plus text-muted" aria-hidden="true"></i></center>
                            <br>
                            <p class="text-muted">No hay artículos seleccionados</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import Multiselect from "vue-multiselect";
  import vue2Dropzone from "vue2-dropzone";
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';
  
  export default {
    name: 'credito',
    components:{
      vue2Dropzone,
      Multiselect
    },
    data() {
      return {
        BASE_URL: process.env.VUE_APP_BASE_URL,
        EMAIL_CREDIT: process.env.VUE_APP_EMAIL_CREDIT_REQUEST,
        loading: true,
        cliente: null,
        razonSocial: null,
        cardCode: null, 
        agenteVentas: null,       
        showForm: false,
        rfc: null,
        loadingRFC:false,
        lineaList:[
          "PVC",
          "Melamina",
          "Madera"
        ],
        linea: null,
        adhesivoList:[
          "Si",
          "No"
        ],
        adhesivo: null,
        colorList:[
          "PVC",
          "Melamina",
          "Madera"
        ],
        color: null,
        anchoList:[
          "PVC",
          "Melamina",
          "Madera"
        ],
        ancho: null,
        espesorList:[
          "PVC",
          "Melamina",
          "Madera"
        ],
        espesor: null,
        acabadoList:[
          "PVC",
          "Melamina",
          "Madera"
        ],
        acabado: null,
        articulosParaCotizar:[],
        cantidad: null,
        whatsappText: '',
        whatsappPhone:'+526141741844'
      }
    },
    created(){
    },
    methods:{
      onSelectLinea(data){
        if(data === 'Melamina'){
          this.adhesivo = "Si"
        }
        else{
          this.adhesivo = null
        }
        
      },
      sendWhatsapp(){
        window.open(`https://api.whatsapp.com/send/?phone=${this.whatsappPhone}&text=${this.whatsappText}`, '_blank');
      },
      deleteArticuloParaCotizar(index){
        this.articulosParaCotizar.splice(index, 1);
      },
      agregarArticulo(){
          this.articulosParaCotizar.push({
            linea: this.linea,
            color: this.color,
            adhesivo: this.adhesivo,
            ancho: this.ancho,
            espesor: this.espesor,
            acabado: this.acabado,
            cantidad: this.cantidad
          })

          this.whatsappText = `Hola ${this.agenteVentas.SalesEmployeeName}, te escribo de ${this.razonSocial} y quiero cotizar los siguientes artículos:%0A%20`
          this.articulosParaCotizar.forEach(element => {
            this.whatsappText += `--------------%0A%20Linea: ${element.linea}%20%0A%20Color: ${element.color}%0A%20Adhesivo: ${element.adhesivo}%0A%20Ancho: ${element.ancho}%0A%20Espesor: ${element.espesor}%0A%20Acabado: ${element.acabado}%0A%20Cantidad: ${element.cantidad}%0A%20`
          });
          this.linea = null;
          this.color = null;
          this.adhesivo = null;
          this.ancho = null;
          this.espesor = null;
          this.acabado = null;
          this.cantidad = null;
      },
      sendRequest(){
      },
      validateRFC(){
        this.loadingRFC = true;
        axios.get(`/api/business_part/${this.rfc}`)
        .then((result) => {
          if(result.data.value.length>0){
            // business_part
            this.cliente = result.data.value[0];
            this.razonSocial = this.cliente.CardName;
            this.cardCode = this.cliente.CardCode;
            this.agenteVentas = this.agenteVentasOptions.find(x => x.SalesEmployeeCode === this.cliente.SalesPersonCode);
            this.showForm = true;
            this.loadingRFC = false;
          }
          else{
            this.razonSocial = null;
            this.agenteVentas = this.agenteVentasOptions.find(x => x.SalesEmployeeCode === 1);
            this.showForm = true;
            this.$swal("", "Este RFC no esta registrado en nuestro sistema", "warning");
            this.loadingRFC = false;
            
          }
        }).catch((error) => {
          this.loadingRFC = false;
        });
        
      }
    },
    mounted() {
      axios.get(`/api/quotation_items_options`)
      .then((result) => {
        this.acabadoList = result.data[0]
        this.anchoList = result.data[1]
        this.colorList = result.data[2]
        this.espesorList = result.data[3]
      })
      .catch((error) => {
        console.log("🚀 ~ file: cotiza.vue:378 ~ mounted ~ error", error)
      });

      axios.get(`/api/sales_persons`)
      .then((result) => {
        this.agenteVentasOptions = result.data.value;
        console.log("🚀 ~ file: cotiza.vue:385 ~ .then ~ this.agenteVentasOptions", this.agenteVentasOptions)
      }).catch((error) => {
        console.log("🚀 ~ file: cotiza.vue:378 ~ mounted ~ error", error)
      });;
      
    },
  };
</script>


